import { Text, Code, Group, createStyles, useMantineTheme } from "@mantine/core";

const useStyles = createStyles((theme) => ({

    groupCard: {
        width: '100%',
        border: `1px solid ${theme.colors.gray[2]}`,
        borderRadius: theme.radius.md,
        padding: theme.spacing.xs,
    },

}));

const FingerprintCard = ({ title, value, color }) => {
    const { classes } = useStyles();


    return (
        <Group className={classes.groupCard} spacing='sm'>
        <Text
            fw='bold'
            size='sm'
        >
            {title}
        </Text >
        <Code size='sm' color={color ?? 'gray'}
        >{value}</Code>
    </Group>
    );
};

export default FingerprintCard;